
// import React, { useEffect, useState } from "react";
// import { formatNumbersWithDecimal } from "../../components/formatNumbersWIthDecimal";
// import axios from "axios";

// function TopSales({ currency }) {
//   const [topProducts, setTopProducts] = useState([]);

//   const fetchData = async () => {
//     try {
//       const token = localStorage.getItem("myToken");
//       const response = await axios.get("https://01pos2.01technologies.net/api/admin/top-selling", {
//         headers: { 
//           Authorization: `Bearer ${token}`, 
//           'Content-Type': 'application/json',  
//           'Accept': 'application/json' 
//         }
//       });

//       const products = response?.data?.data?.products || [] || null;

//     console.log(products)
//       const sortedProducts = [...products]
//         .sort((a, b) => (Number(b.quantity_purchased) || 0) - (Number(a.quantity_purchased) || 0));

//       setTopProducts(sortedProducts);
//     } catch (err) {
//       console.log("Error fetching top selling products", err);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   return (
//     <tbody>
//       {topProducts.length > 0 ? (
//         topProducts.map((product, index) => {
//           const qtySold = Number(product.quantity_purchased) || 0;
//           const price = Number(product.price) || 0;
//           const totalSales = qtySold * price;
// //           const firstLetter = categoryName.charAt(0).toUpperCase();

//           return (
//             <tr
//               key={product.id}
//               className="hover:bg-gray-100 border-b border-gray-300"
//             >
//               {/* RANK */}
//               <td className="py-4 px-6 text-center font-bold text-gray-800 text-lg">
//                 {index + 1}
//               </td>

//               {/* PRODUCT NAME + ICON */}
//               <td className="py-4 px-6">
//                 <div className="flex items-center gap-4">
                 
//                   <span className="font-medium text-gray-800">
//                     {product.product_name}
//                   </span>
//                 </div>
//               </td>

//               {/* CATEGORY */}
//               <td className="py-4 px-6 text-center text-gray-600">
//                 {categoryName}
//               </td>

//               {/* QTY SOLD */}
//               <td className="py-4 px-6 text-center font-semibold text-gray-900">
//                 {qtySold}
//               </td>

//               {/* TOTAL SALES */}
//               <td className="py-4 px-6 text-center font-bold text-green-600 text-lg">
//                 {currency}{formatNumbersWithDecimal(totalSales)}
//               </td>
//             </tr>
//           );
//         })
//       ) : (
//         <tr>
//           <td colSpan={4} className="py-12 text-center text-gray-500">
//             No top-selling products yet
//           </td>
//         </tr>
//       )}
//     </tbody>
//   );
// }

// export default TopSales;

import React, { useEffect, useState } from "react";
import { formatNumbersWithDecimal } from "../../components/formatNumbersWIthDecimal";
import axios from "axios";

function TopSales({ currency }) {
  const [topProducts, setTopProducts] = useState([]);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("myToken");
      const response = await axios.get("https://01pos2.01technologies.net/api/admin/top-selling", {
        headers: { 
          Authorization: `Bearer ${token}`, 
          'Content-Type': 'application/json',  
          'Accept': 'application/json' 
        }
      });

      const products = response?.data?.data?.products || [];

      // Sort by QTY SOLD, highest first (total sales breaks ties)
      const sortedProducts = [...products]
        .map(product => ({
          ...product,
          totalSales: (Number(product.quantity_purchased) || 0) * (Number(product.price) || 0)
        }))
        .sort(
          (a, b) =>
            (Number(b.quantity_purchased) || 0) - (Number(a.quantity_purchased) || 0) ||
            b.totalSales - a.totalSales
        )
        .slice(0, 5); // Only top 5

      setTopProducts(sortedProducts);
    } catch (err) {
      console.log("Error fetching top selling products", err);
      setTopProducts([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <tbody>
      {topProducts.length > 0 ? (
        topProducts.map((product, index) => {
          const qtySold = Number(product.quantity_purchased) || 0;
          const price = Number(product.price) || 0;
          const totalSales = qtySold * price;

          return (
            <tr
              key={product.id}
              className="hover:bg-gray-100 border-b text-sm border-gray-300"
            >
              {/* RANK */}
              <td className="py-4 px-6 text-center font-bold text-gray-800 text-lg">
                {index + 1}
              </td>

              {/* PRODUCT NAME + ICON */}
              <td className="py-4 px-6">
                <div className="flex items-center gap-4">
               
                  <span className="font-medium text-gray-800">
                    {product.product_name}
                  </span>
                </div>
              </td>

              {/* QTY SOLD */}
              <td className="py-4 px-6 text-center font-semibold text-gray-900">
                {qtySold}
              </td>

              {/* TOTAL SALES - HIGHLIGHTED */}
              <td className="py-4 px-6 text-center font-bold text-green-600 text-lg">
                {currency}{formatNumbersWithDecimal(totalSales)}
              </td>
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan={5} className="py-12 text-center text-gray-500">
            No top-selling products yet
          </td>
        </tr>
      )}
    </tbody>
  );
}

export default TopSales;